export default [
    // network home & subpages
    {
        path: '/networks/:slug',
        props: true,
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/Index.vue'),
        children: [
            {
                path: '',
                name: 'network-home',
                props: true,
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/Home.vue'),
            },
            {
                path: 'dashboard',
                redirect: to => `/networks/${to.params.slug}/insights`,
            },
            {
                path: 'insights',
                name: 'networks-insights',
                props: true,
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/insights/Index.vue'),
            },
            {
                path: 'media',
                name: 'network-page',
                props: true,
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/feed/index.vue'),
            },
            {
                path: 'courses',
                name: 'network-courses',
                props: true,
                component: () => import(/* webpackchunkname: "courses" */ '@/views/courses/feed/index.vue'),
            },
            {
                path: 'media/:media_slug',
                props: true,
                name: 'network_media',
                component: () => import(/* webpackchunkname: "network_media" */ '@/views/networks/media/Show.vue'),
            },
            {
                path: 'media/:media_slug/edit',
                props: true,
                name: 'network_media_update',
                component: () => import(/* webpackchunkname: "network_media" */ '@/views/networks/media/Update.vue'),
            },
            {
                path: 'collections/:collection_slug',
                props: true,
                name: 'network_collection',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/collections/Show.vue'),
            },
            {
                path: 'collections/:collection_slug/edit',
                props: true,
                name: 'network_collection_update',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/collections/Update.vue'),
            },
            {
                path: 'members',
                name: 'networks-members',
                props: true,
                //meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/members/Index.vue'),
            },
            {
                path: 'members/invite-members',
                name: 'invite-networks-members',
                props: true,
                meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/members/Invite.vue'),
            },
            {
                path: 'messages',
                name: 'networks-messages',
                props: true,
                meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/messages/Index.vue'),
            },
            {
                path: 'messages/create',
                props: true,
                name: 'network-message-create-page',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/messages/Create.vue'),
            },
            {
                path: 'messages/:id',
                name: 'network-message-show-page',
                props: true,
                meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/messages/Show.vue'),
            },
            {
                path: 'messages/:id/edit',
                name: 'network-message-edit-page',
                props: true,
                meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/messages/Create.vue'),
            },
            {
                path: 'meetings',
                name: 'networks-meetings',
                props: true,
                meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/Index.vue'),
            },

            {
                path: 'meetings/certificates',
                name: 'meeting-certificates',
                props: true,
                meta: { authRequired: true, roles: ['super-admin'] },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/AttendanceCertificates.vue'),
            },

            {
                path: 'meetings/:id',
                name: 'single-network-meeting-page',
                props: true,
                //meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/Show.vue'),
            },

            {
                path: 'meetings/report/:id',
                props: true,
                name: 'meeting-report',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/AttendanceReport.vue'),
            },

            {
                path: 'meetings/zoom-attendees/:id',
                props: true,
                name: 'zoom-report',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/ZoomAttendees.vue'),
            },

            {
                path: 'create-media',
                props: true,
                name: 'networks-create-media',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/Create.vue'),
            },
            {
                path: 'templates',
                name: 'network-email-templates',
                props: true,
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/templates/Index.vue'),
            },
            {
                path: 'edit',
                name: 'networks-edit',
                props: true,
                meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/crud/Edit.vue'),
            },
            {
                path: 'blog',
                name: 'networks-blog',
                props: true,
                meta: { authRequired: true },
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/blog/Index.vue'),
            },
            {
                path: 'blog/post/create',
                props: true,
                name: 'network-blog-post-create-page',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/blog/Create.vue'),
            },
            {
                path: 'blog/post/:id',
                props: true,
                name: 'network-blog-post-show-page',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/blog/Show.vue'),
            },
            {
                path: 'blog/post/:id/edit',
                props: true,
                name: 'network-blog-post-edit-page',
                component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/blog/Create.vue'),
            },
        ],
    },

    // rest of the routes (media, users etc)
    {
        path: '/networks/media/:media_slug',
        redirect: '/media/:media_slug',
    },
    {
        path: '/networks/media/:media_slug/edit',
        redirect: '/media/:slug/edit',
    },
    {
        path: '/media/:media_slug',
        props: true,
        name: 'show-media-page',
        component: () => import(/* webpackchunkname: "network_media" */ '@/views/networks/media/Show.vue'),
    },
    {
        path: '/media/:slug/edit',
        props: true,
        name: 'update-network-media-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/Update.vue'),
    },

    {
        path: '/users',
        props: true,
        name: 'network_users',
        component: () => import(/* webpackchunkname: "network_media" */ '@/views/networks/users/Index.vue'),
    },
    {
        path: '/users/:id',
        props: true,
        name: 'network_users_show',
        component: () => import(/* webpackchunkname: "network_media" */ '@/views/networks/users/Show.vue'),
    },
    {
        path: '/networks/:slug/meeting',
        props: true,
        name: 'create-network-meeting-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/Create.vue'),
    },
    {
        path: '/networks/meeting/:id/edit',
        props: true,
        name: 'update-network-meeting-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/Update.vue'),
    },
    {
        path: '/networks/join-meeting/:id',
        name: 'join-meeting',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/meetings/JoinMeeting.vue'),
    },
    {
        path: '/networks/:slug/create-collection',
        props: true,
        name: 'create-network-collection-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/collections/Create.vue'),
    },
    {
        path: '/networks/collections/:collection_slug',
        props: true,
        name: 'show-network-collection-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/collections/ShowWithLayout.vue'),
    },
    {
        path: '/networks/collections/:collection_slug/edit',
        props: true,
        name: 'update-network-collection-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/media/collections/Update.vue'),
    },
    {
        path: '/networks/:slug/template/create',
        props: true,
        name: 'network-template-create-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/templates/Create.vue'),
    },
    {
        path: '/networks/:slug/template/:id/edit',
        props: true,
        name: 'network-template-edit-page',
        component: () => import(/* webpackchunkname: "networks" */ '@/views/networks/templates/Create.vue'),
    },
];
